var React = require('react');

function TrophyIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M42.466 4.919A47.966 47.966 0 0 0 42.631 0H9.837a47.965 47.965 0 0 0 .162 4.919h-10v1.639c0 14.594 18.53 24.924 22.958 27.218v5.577a4.83 4.83 0 0 1-4.926 4.918h-3.28v6.558H37.71v-6.558h-3.279a4.83 4.83 0 0 1-4.921-4.921v-5.572c4.427-2.3 22.957-12.627 22.957-27.218V4.922zM3.443 8.2h6.888a43.128 43.128 0 0 0 4.427 16.4C9.508 20.5 4.099 14.757 3.442 8.2zm34.433 16.4a43.145 43.145 0 0 0 4.423-16.4h6.887c-.822 6.558-6.232 12.3-11.314 16.4z"}));
}

TrophyIcon.defaultProps = {"viewBox":"0 0 52.467 50.829","className":"icon trophy"};

module.exports = TrophyIcon;

TrophyIcon.default = TrophyIcon;
